export enum SettingChildTab {
  Conversation = 'settings/channel',
  Expert = 'settings/expert',
  Contact = 'settings/customer',
  Ticket = 'settings/ticket',
  Switchboard = 'settings/switchboard',
  Other = 'settings/other',
  TimeWorking = 'settings/working-time',
  Blacklist = 'settings/blacklist',
  Account = 'settings/tenant',
}
export const SettingTabList = [
  {
    id: SettingChildTab.Expert,
    title: 'Chuyên viên',
  },
  {
    id: SettingChildTab.Contact,
    title: 'Khách hàng',
  },
  {
    id: SettingChildTab.Ticket,
    title: 'Ticket',
  },
  {
    id: SettingChildTab.Switchboard,
    title: 'Tổng đài',
  },
  {
    id: SettingChildTab.TimeWorking,
    title: 'Thời gian làm việc',
  },
  {
    id: SettingChildTab.Blacklist,
    title: 'Blacklist',
  },
];
export function getCurrentTab(url) {
  let tab = '';
  Object.keys(SettingChildTab).forEach(s => {
    if (url.includes(SettingChildTab[s])) {
      tab = SettingChildTab[s];
    }
  });
  return tab;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/setting.const.ts